














































import {Component, Prop, Watch} from "vue-property-decorator";
import AsiAvatar from "@/components/common/AsiAvatar.vue";
import AsiContentContainer from "@/components/common/AsiContentContainer.vue";
import AsiSelectSimple from "@/components/common/AsiSelectSimple";
import AsiListTableLayout from "@/components/common/AsiListTableLayout.vue";
import AsiSelect from "@/components/common/AsiSelect";
import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
import AsiListTable from "@/components/common/AsiListTable.vue";
import AsiListTableOptions from "@/components/common/AsiListTableOptions";
import PaginatedResponse from "@/models/PaginatedResponse";
import BillListFilter from "@/models/bill/BillListFilter";
import BillListEntry from "@/models/bill/BillListEntry";
import IAsiListTableImplementation from "@/components/common/IAsiListTableImplementation";
import AsiListTableHeader from "@/components/common/AsiListTableHeader";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import {enumTextFromValue, enumToSelectItems} from "@/helpers/functions_asi";
import {BillState, CompanyType, Permissions} from "@/helpers/constants";
import Company from "@/models/company/Company";
import CompanySimple from "@/models/company/CompanySimple";
import {Icon} from "@/helpers/icons";
import {getCompanyIcon} from "@/helpers/functions_td";

@Component({
	components: {
		AsiAvatar,
		AsiContentContainer,
		AsiSelectSimple,
		AsiListTableLayout, AsiSelect, AsiTextFieldSimple, AsiListTable, AsiDatePicker
	}
})
export default class BillList extends AsiListTable<BillListEntry, BillListFilter> implements IAsiListTableImplementation<BillListEntry, BillListFilter> {

	@Prop({type: Object, default: null})
	public company!: Company | null;

	@Prop({type: Boolean, default: false})
	public hideToolbar!: boolean;

	@Prop({type: Object, default: null})
	public billFilterModel!: BillListFilter | null;

	protected companyTypeOptions = enumToSelectItems(CompanyType, true);
	protected billStateOptions = enumToSelectItems(BillState, true);
	private icons = Icon;
	private booleanItems = [
		{value: true, text: this.$t('ui.yes')},
		{value: false, text: this.$t('ui.no')},
	];

	public constructor() {
		super();
		this.filterModel = this.createFilterModel();
	}

	public mounted(): void {
		this.tableOptions.sortBy = ['billingDate'];
		this.tableOptions.sortDesc = [true];
	}

	private get dateRange(): string[] | null {
		if (this.filterModel === null) return null;
		const ret = [];
		if (this.filterModel.dateFrom !== null) ret.push(this.filterModel.dateFrom);
		if (this.filterModel.dateTo !== null) ret.push(this.filterModel.dateTo);
		return ret;
	}

	private set dateRange(value: string[] | null) {
		if (this.filterModel === null) return;
		this.filterModel.dateFrom = value === null ? null : (value[0] ?? null);
		this.filterModel.dateTo = value === null ? null : (value[1] ?? null);
	}

	private get isInternal(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightInternal);
	}

	private get isCustomer(): boolean {
		return this.$store.getters['user/hasPermission'](Permissions.rightCustomer);
	}

	public createFilterModel(): BillListFilter {
		return this.billFilterModel ?? (this.isCustomer ? new BillListFilter([BillState.locked]) : new BillListFilter());
	}

	public createHeaders(): AsiListTableHeader[] {
		const ret: AsiListTableHeader[] = [];

		if (this.company === null) {
			ret.push(new AsiListTableHeader('', 'avatar', false, false, 'center', '4rem'));
			ret.push(new AsiListTableHeader(this.$t('company.singular').toString(), 'company', true, true, 'start', '20%'));
		}

		ret.push(
			new AsiListTableHeader(this.$t('bill.billingDate').toString(), 'billingDate', true, true, 'start', '12rem'),
			new AsiListTableHeader(this.$t('bill.number').toString(), 'number', true, true, 'start', '17%'),
			new AsiListTableHeader(this.$t('bill.name').toString(), 'name', true, true, 'start'),
			new AsiListTableHeader(this.$t('bill.state').toString(), 'state', true, true, 'start', '10%'),
			new AsiListTableHeader(this.$t('bill.isPaid').toString(), 'isPaid', true, true, 'start', '8rem'),
		);

		return ret;
	}

	public fetchData(filterModel: BillListFilter | null, tableOptions: AsiListTableOptions | null): Promise<PaginatedResponse<BillListEntry>> {
		if (this.company === null) {
			return this.$billService.bills(filterModel, tableOptions);
		} else {
			return this.$companyService.bills(this.company.id, filterModel, tableOptions);
		}
	}

	public filterTextChanged(filterText: string): void {
		if (this.filterModel === null) return;
		this.filterModel.fulltext = filterText;
	}

	public openModelDetailPage(model: BillListEntry): void {
		this.$router.push({name: 'Bill', params: {id: model.id}})
	}

	public reload(goToFirstPage: boolean = false): void {
		this.reloadInternal(this, goToFirstPage);
	}

	protected companyTypeIcon(type: CompanyType): string {
		return getCompanyIcon(type);
	}

	protected companyTypeLabel(type: CompanyType): string | null {
		return enumTextFromValue(CompanyType, type, true);
	}

	protected billStateLabel(state: BillState): string | null {
		return enumTextFromValue(BillState, state, true);
	}

	protected avatarUrl(company: CompanySimple): string | null {
		return CompanySimple.avatarUrlMedium(company);
	}

	private isDraft(bill: BillListEntry): boolean {
		return bill.state === BillState.draft;
	}

	@Watch('tableOptions', {deep: true})
	private onTableOptionsChanged(): void {
		this.reload();
	}

	@Watch('filterModel', {deep: true})
	private onFilterModelChanged(): void {
		this.reload(true);
	}

}
